/**
 * 员工选择公共组件接口
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async popSelectWithUser(kws,parentId) {
    return request(api.comm.DEPT + '/popSelectWithUser?userName=' + kws +'&parentId='+parentId, METHOD.GET);
  },
  async popSelect(kws) {
    return request(api.comm.DEPT + '/popSelect?deptName=' + kws, METHOD.GET);
  },
  async popSelectTree(kws,parentId) {
    return request(api.comm.DEPT + '/popSelect?deptName=' + kws + '&parentId=' + parentId, METHOD.GET);
  },
  async selectUserListByDeptId(deptId, userName) {
    return request(api.comm.USER + '/selectUserListByDeptId?deptId=' + deptId + '&userName=' + userName, METHOD.GET);
  },
}


export default {dataApi}